import { TThunkAction } from '../../types/redux';
import {
  fetchSaveRecommendation,
  TSaveRecommendationRequest as IReq,
  ISaveRecommendationResponse200 as IRes200,
  ISaveRecommendationResponse400 as IRes400,
} from '../../common/repositories/job-vacancies-backend/v2/save-recommendation';
import { setErrors, setIsLoading, setIsSubmitted } from './actions';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export const sendRecommendation =
  (data: IReq): TThunkAction =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(setIsLoading(true));
    dispatch(setErrors({}));

    try {
      const result = await fetchSaveRecommendation<IRes200, IRes400>({
        httpApi,
        parameters: data,
      });

      if (result.statusCode === 200) {
        dispatch(setIsSubmitted(true));
        dispatch(setIsLoading(false));

        return result.response;
      }

      const errors: { [key: string]: string } = {};

      result.response.errors?.forEach((error: { key: string; message: string }) => {
        Object.defineProperty(errors, error.key, {
          value: error.message,
        });
      });
      dispatch(setErrors(errors));

      throw new HttpBadStatusCodeError({
        message: result?.response?.message || 'Error in send recommendation request',
        domain: 'sendRecommendation',
        statusCode: result.statusCode,
      });
    } catch (e) {
      dispatch(setIsLoading(false));
      logger.error(e, { domain: 'sendRecommendation' });
    }
  };
